import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NotificationType } from 'app/types/types'

export interface Toast {
  id: string
  message: string
  type: NotificationType
  duration: number // seconds
}

export interface ToastState {
  toasts: Toast[]
}

const initialState: ToastState = {
  toasts: []
}

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<{ message: string; type?: NotificationType; duration?: number }>) => {
      const id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
      const toast: Toast = {
        id,
        message: action.payload.message,
        type: action.payload.type || 'info',
        duration: action.payload.duration ?? 3
      }
      if (state.toasts.length >= 3) {
        state.toasts.shift() // remove oldest
      }
      state.toasts.push(toast)
    },
    hideToast: (state, action: PayloadAction<{ id: string }>) => {
      state.toasts = state.toasts.filter(t => t.id !== action.payload.id)
    },
    hideOldestToast: state => {
      state.toasts.shift()
    },
    clearToasts: state => {
      state.toasts = []
    }
  }
})

export const { showToast, hideToast, hideOldestToast, clearToasts } = toastSlice.actions

export default toastSlice.reducer
